type BgImages = {
  [key: string]: string;
};

const bgImages: BgImages = {
  cycling: require('assets/images/classes/cycling.png'),
  meditation: require('assets/images/classes/meditation.png'),
  mma: require('assets/images/classes/mma.png'),
  karate: require('assets/images/classes/karate.png'),
  powerlifting: require('assets/images/classes/powerlifting.png'),
  workout: require('assets/images/classes/workout.png'),
  crossfit: require('assets/images/classes/crossfit.png'),
  running: require('assets/images/classes/running.png'),
  barre: require('assets/images/classes/barre.png'),
  bodybuilding: require('assets/images/classes/bodybuilding.png'),
  flyingyoga: require('assets/images/classes/flyingyoga.png'),
  trx: require('assets/images/classes/trx.png'),
  step: require('assets/images/classes/step.png'),
  box: require('assets/images/classes/box.png'),
  fitness: require('assets/images/classes/fitness.png'),
  yoga: require('assets/images/classes/yoga.png'),
};

type ClassesBox = {
  bgImg: string;
  title: string;
  trainer: string;
  date: string;
};

const classesBox: ClassesBox[] = [
  {
    bgImg: 'cycling',
    title: 'Cycling',
    trainer: 'Rajveer Singh',
    date: 'Wed: 9:00 am',
  },
  {
    bgImg: 'meditation',
    title: 'Meditation',
    trainer: 'Priya Sharma',
    date: 'Fri: 1:00 pm',
  },
  {
    bgImg: 'mma',
    title: 'Boxing',
    trainer: 'Arjun Rana',
    date: 'Tue: 4:00 pm',
  },
  {
    bgImg: 'karate',
    title: 'Karate',
    trainer: 'Devender Chauhan',
    date: 'Sat: 9:00 am',
  },
  {
    bgImg: 'powerlifting',
    title: 'Power Lifting',
    trainer: 'Vikram Solanki',
    date: 'Mon: 8:00 pm',
  },
  {
    bgImg: 'workout',
    title: 'Workout',
    trainer: 'Rohan Malik',
    date: 'Sun: 10:00 am',
  },
  {
    bgImg: 'crossfit',
    title: 'Crossfit',
    trainer: 'Anjali Dhillon',
    date: 'Wen: 9:00 pm',
  },
  {
    bgImg: 'running',
    title: 'Running',
    trainer: 'Riya Chahal',
    date: 'Fri: 6:00 am',
  },
  {
    bgImg: 'barre',
    title: 'Barre',
    trainer: 'Jasleen Kaur',
    date: 'Thu: 02:00 pm',
  },
  {
    bgImg: 'meditation',
    title: 'Meditation',
    trainer: 'Priya Sharma',
    date: 'Fri: 1:00 pm',
  },
  {
    bgImg: 'mma',
    title: 'Boxing',
    trainer: 'Arjun Rana',
    date: 'Tue: 4:00 pm',
  },
  {
    bgImg: 'karate',
    title: 'Karate',
    trainer: 'Devender Chauhan',
    date: 'Sat: 9:00 am',
  },
  {
    bgImg: 'powerlifting',
    title: 'Power Lifting',
    trainer: 'Vikram Solanki',
    date: 'Mon: 8:00 pm',
  },
  {
    bgImg: 'workout',
    title: 'Workout',
    trainer: 'Rohan Malik',
    date: 'Sun: 10:00 am',
  },
  {
    bgImg: 'crossfit',
    title: 'Crossfit',
    trainer: 'Anjali Dhillon',
    date: 'Wen: 9:00 pm',
  },
  {
    bgImg: 'running',
    title: 'Running',
    trainer: 'Riya Chahal',
    date: 'Thu: 12:00 am',
  },
  {
    bgImg: 'bodybuilding',
    title: 'Body Building',
    trainer: 'Kabir Yadav',
    date: 'Mon: 8:00 pm',
  },
  {
    bgImg: 'box',
    title: 'MMA',
    trainer: 'Kiran Bhati',
    date: 'Fri: 6:00 am',
  },
  {
    bgImg: 'yoga',
    title: 'Yoga',
    trainer: 'Meera Singh',
    date: 'Wen: 8:00 am',
  },
  {
    bgImg: 'fitness',
    title: 'Fitness',
    trainer: 'Nisha Verma',
    date: 'Sat: 5:00 pm',
  },
  {
    bgImg: 'flyingyoga',
    title: 'Flying Yoga',
    trainer: 'Sheetal Rathi',
    date: 'Fri: 5:00 pm',
  },
  {
    bgImg: 'trx',
    title: 'TRX',
    trainer: 'Jai Chauhan',
    date: 'Wen: 8:00 am',
  },
  {
    bgImg: 'step',
    title: 'Step',
    trainer: 'Aarti Nagar',
    date: 'Tue: 10:00 am',
  },
  {
    bgImg: 'barre',
    title: 'Barre',
    trainer: 'Jasleen Kaur',
    date: 'Mon: 05:00 pm',
  },
];


export { bgImages, classesBox };
